import React, { useState, useEffect, memo } from 'react';
import { Clock } from 'lucide-react';

import CheckIn from './tabs/checkin';
import Info from './tabs/info';
import Meals from './tabs/meals';

// Memoized clock component to prevent unnecessary re-renders
const LiveClock = memo(() => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    // Update every second
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    // Cleanup interval on unmount
    return () => clearInterval(timer);
  }, []);

  return (
    <div className='flex items-center mb-4 space-x-2 text-gray-600'>
      <Clock className='h-5 w-5' />
      <span className='text-lg'>
        {time.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })}
      </span>
    </div>
  );
});

LiveClock.displayName = 'LiveClock';

const TabButton = ({ active, onClick, children }) => (
  <button
    className={`px-4 py-2 font-medium rounded-t-lg ${
      active
        ? 'bg-white text-blue-600 border-b-2 border-blue-600'
        : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
    }`}
    onClick={onClick}>
    {children}
  </button>
);

const Mentor = ({ user }) => {
  const [activeTab, setActiveTab] = useState('info');

  const tabs = {
    info: <Info user={user} />,
    check_in: <CheckIn user={user} />,
    meals: <Meals user={user} />,
  };

  return (
    <div className='max-w-4xl mx-auto p-4 w-full'>
      <LiveClock />
      <div className='border rounded-lg shadow-sm'>
        <div className='bg-gray-50 border-b flex'>
          <TabButton
            active={activeTab === 'info'}
            onClick={() => setActiveTab('info')}>
            Mentor Info
          </TabButton>
          <TabButton
            active={activeTab === 'check_in'}
            onClick={() => setActiveTab('check_in')}>
            Mentor Check-in
          </TabButton>
          <TabButton
            active={activeTab === 'meals'}
            onClick={() => setActiveTab('meals')}>
            Mentor Meals
          </TabButton>
        </div>

        <div className='bg-white rounded-b-lg'>{tabs[activeTab]}</div>
      </div>
    </div>
  );
};

export default Mentor;
